import React, { useMemo } from "react";
import { EmptyState } from "@toddle-edu/ds-web";
import { useTranslation } from "react-i18next";
import classes from "./StandardSetsTable.scss";
import FeedListv2 from "AppComponents/FeedListv2";
import getCustomComponent from "./components/getCustomComponent";
import { getTransformedData } from "../../modules/utils";
import _ from "lodash";
import {
  NoFilterResultIllustration,
  NoServiceAsActionInsightsIllustration,
} from "@toddle-edu/ds-theme";

const TEST_ID_PREFIX = "planning-standardSetsTable";

const styles = {
  feedListContainerStyle: {
    height: "100%",
  },
  subtitleStyle: {
    width: "280px",
  },
};

const StandardSetsTable = props => {
  const { standardEdges = [], value, setStandardSetId, searchText } = props;

  const { t } = useTranslation(["common", "scopeAndSequence"]);

  const { columnList, feedData } = useMemo(() => {
    const filteredStandardEdges = _.filter(standardEdges, ({ standardSet }) => {
      return _.chain(standardSet.title)
        .toLower()
        .includes(_.toLower(searchText))
        .value();
    });

    return getTransformedData({
      t,
      standardEdges: filteredStandardEdges,
      value,
    });
  }, [searchText, standardEdges, t, value]);

  if (_.isEmpty(standardEdges))
    return (
      <EmptyState
        illustration={NoServiceAsActionInsightsIllustration}
        title={t("scopeAndSequence:no_standard_sets_added")}
        subtitle={t("scopeAndSequence:no_standard_sets_added_subtitle")}
        subtitleStyle={styles.subtitleStyle}
      />
    );

  return (
    <div className={classes.container}>
      <div className={classes.feedContainer}>
        <FeedListv2
          columnList={columnList}
          feedData={feedData}
          testId={TEST_ID_PREFIX}
          getCustomComponent={getCustomComponent}
          isData={true}
          containerStyle={styles.feedListContainerStyle}
          enableStickyHeader
          onItemClick={setStandardSetId}
          emptyComponent={
            <EmptyState
              illustration={NoFilterResultIllustration}
              title={t("common:noResultHeading")}
              subtitle={t("common:noResultMsg")}
              subtitleStyle={styles.subtitleStyle}
            />
          }
        />
      </div>
    </div>
  );
};

export default StandardSetsTable;
